import React from 'react';
import { isMobile, isTablet } from 'react-device-detect';
import styled from 'styled-components';
import { isNotStandaloneMobilePWA } from '../../../utils/mobileSupported';
import { BATTLES_TAB_CURRENT_INFO_ID } from '../constants';
const BattlesTabsHeader = ({ battlesAssets, activeTab, onClick }) => {
  return (
    <>
      <BackgroundActive
        id={BATTLES_TAB_CURRENT_INFO_ID}
        src={battlesAssets.BATTLES_MODAL_CURRENT_INFO}
        activeTab={activeTab}
      />
      <BackgroundInactive src={battlesAssets.BATTLES_MODAL_STREAK_INFO} activeTab={activeTab} />
      <Clickable onClick={onClick} />
    </>
  );
};

export default BattlesTabsHeader;

const isMobileBrowser = isMobile && isNotStandaloneMobilePWA && !isTablet;

const BackgroundActive = styled.img`
  position: absolute;
  width: ${isMobileBrowser ? 23 : 33}vw;
  display: flex;
  opacity: ${({ activeTab }) => (!activeTab ? 1 : 0)};
`;

const BackgroundInactive = styled.img`
  position: absolute;
  width: ${isMobileBrowser ? 23 : 33}vw;
  display: flex;
  opacity: ${({ activeTab }) => (activeTab ? 1 : 0)};
`;

const Clickable = styled.div`
  z-index: 10;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 7vh;
  margin-top: 2vh;
`;

